
import DefaultLayout from "./layouts/DefaultLayout.vue";
import SimpleLayout from "./layouts/SimpleLayout.vue";

import Header from "./Header.vue";

import Breadcrumbs from "./Breadcrumbs.vue";

import Container from "./Container.vue";
import Card from "./Card.vue";
import CardRow from "./CardRow.vue";
import CardHeader from "./CardHeader.vue";

import DataTable from "./DataTable.vue";
import IconTooltip from "./IconTooltip.vue";

import Sheet from "./Sheet.vue";

import InputGroup from "./InputGroup.vue";
import FormGroup from "./FormGroup.vue";

import BoolIcon from "./BoolIcon.vue";
import Stamp from "./Stamp.vue";
import Chip from "./Chip.vue";
import BoxLink from "./BoxLink.vue";

import ButtonFill from "./ButtonFill.vue";
import Delete from "./Delete.vue";
import Remove from "./Remove.vue";

import TimezoneWarning from "./TimezoneWarning.vue";

import LeaveImpersonationButton from "./LeaveImpersonationButton";

export default {
  install(Vue) {
    Vue.component("d-layout", DefaultLayout);
    Vue.component("d-layout-simple", SimpleLayout);

    Vue.component("d-header", Header);

    Vue.component("d-breadcrumbs", Breadcrumbs);

    Vue.component("d-container", Container);
    Vue.component("d-card", Card);
    Vue.component("d-card-row", CardRow);
    Vue.component("d-card-header", CardHeader);

    Vue.component("d-data-table", DataTable);
    Vue.component("d-icon-tooltip", IconTooltip);

    Vue.component("d-sheet", Sheet);

    Vue.component("d-input-group", InputGroup);
    Vue.component("d-form-group", FormGroup);

    Vue.component("d-bool-icon", BoolIcon);
    Vue.component("d-stamp", Stamp);
    Vue.component("d-chip", Chip);
    Vue.component("d-box-link", BoxLink);

    Vue.component("d-button-fill", ButtonFill);
    Vue.component("d-delete", Delete);
    Vue.component("d-remove", Remove);

    Vue.component("d-timezone-warning", TimezoneWarning);

    Vue.component("d-leave-impersonation", LeaveImpersonationButton);
  }
};
